export const getCategoriedReports = (reports, category) => {
  return reports ? reports.filter(report => report.category === category) : [];
};

export const getScheduledReports = reports => {
  return reports.filter(report => report.isScheduled === true);
};

export const getTotalReports = reports => {
  const business = getCategoriedReports(reports, 'business').length;
  const user = getCategoriedReports(reports, 'user').length;
  const legacy = getCategoriedReports(reports, 'legacy').length;

  return {
    legacy,
    business,
    user
  };
};

export const getBusinessReportNameById = (reports, id) => {
  return reports.find(report => report.id === id).name;
};

export const getSelectedFields = fields => {
  return fields
    .filter(field => field.selected)
    .sort((a, b) => a.sequenceId - b.sequenceId);
};

export const formatSelectedFields = fields => {
  return fields.map(field => field.id);
};

export const searchReports = (value, reports) => {
  const keyword = value.toLowerCase();

  return reports.filter(report => {
    const title = report.name && report.name.toLowerCase();
    const description = report.description && report.description.toLowerCase();
    if (title && title.includes(keyword)) return true;
    if (description && description.includes(keyword)) return true;
    return false;
  });
};

export const getFilterByTitle = (filters, title) => {
  return filters.find(filter => filter.title === title);
};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/helper.js